import { Flex } from 'antd';
import type { FC } from 'react';
import { SponsorLogos } from '../SponsorLogos';
import { Table } from './Table';

export const Leaderboard: FC = () => {
  return (
    <Flex vertical style={{ height: '100%', minHeight: '300px' }}>
      <Table />
      <SponsorLogos />
    </Flex>
  );
};
